/**
 * Created by a.itsekson on 05.07.2016.
 */

import { Injectable } from "@angular/core";
import { Http, Headers, Response } from "@angular/http";
import { CONFIG } from "../config";
import * as Rx from "rxjs/Rx";
import { Observable } from "rxjs";
import { ProductGroup } from "../model/product.group";
import { Product } from "../model/product";
import { InputSubProductInterface, SubProduct } from "../model/subproduct";
import { Logger } from "../utils/logger";

import { Router, ActivatedRoute } from "@angular/router";
import { TranslateService } from '@ngx-translate/core';

declare class Papa {
    static parse(url: string, params: any);
}


export interface RoomConfigurationInterface {
    Name: string,
    Title: string,
    Subtitle1: string,
    Subtitle2: string,
    FirstPageImage: string,
    BaseImage: string,
    TopImage: string,
    ProductGroup: any
}

export interface MainConfigurationInterface {
    Client: string,
    MagentoUrl: string,
    LogoUrl: string,
    PageTitle: string,
    ProductColumns?: number,
    SubProductColumns?: number,
    StartScreen: {
        Title: string,
        Subtitle1: string,
        Subtitle2: string,
        BackgroundImage: string
    },
    Email: {
        Subject: string,
        FromAddress: string,
        Body: string
    },
    PriceUnit: string,
    ShowPrice: boolean,
    ShowSumPrice: boolean,
    Room: Array<RoomConfigurationInterface>
}

@Injectable()
export class ConfigurationLoader {
    private oldStoreId: any;
    private storeId: any;
    private updateConfiguration: boolean;

    private mainConfiguration: MainConfigurationInterface;
    private roomConfiguration: Array<RoomConfigurationInterface>;

    private defaultConfiguration: MainConfigurationInterface = {
        Client: "",
        MagentoUrl: "",
        LogoUrl: "",
        PageTitle: "",
        StartScreen: {
            Title: "",
            Subtitle1: "",
            Subtitle2: "",
            BackgroundImage: ""
        },
        Email: {
            Subject: "",
            FromAddress: "",
            Body: ""
        },
        PriceUnit: "Kr/m2",
        ShowPrice: false,
        ShowSumPrice: false,
        Room: [{
            Name: "",
            Title: "",
            Subtitle1: "",
            Subtitle2: "",
            FirstPageImage: "",
            BaseImage: "",
            TopImage: "",
            ProductGroup: [
                {
                    "Name": "Golv",
                    "Table": "tables/kitchen_floors.csv",
                    "SubProductTable": "tables/livingroom/livingroom_floors_subproduct.csv",
                    "ButtonPosX": 25,
                    "ButtonPosY": 56,
                    "DefaultChoice": 1
                },
                {
                    "Name": "Takpanel",
                    "Table": "tables/kitchen_ceiling.csv",
                    "SubProductTable": "tables/livingroom/livingroom_floors_subproduct.csv",
                    "ButtonPosX": 45,
                    "ButtonPosY": 19,
                    "DefaultChoice": 0
                },
                {
                    "Name": "Väggpanel",
                    "Table": "tables/kitchen_walls.csv",
                    "SubProductTable": "tables/livingroom/livingroom_floors_subproduct.csv",
                    "ButtonPosX": 39,
                    "ButtonPosY": 77,
                    "DefaultChoice": 0
                }
            ]
        }]
    };

    constructor(private translate: TranslateService, private http: Http, private logger: Logger) {
        this.roomConfiguration = [];
    }

    setStore(storeId): void {
        this.updateConfiguration = false;
        this.storeId = storeId;

        if (this.oldStoreId !== storeId) {
            this.oldStoreId = storeId;

            this.updateConfiguration = true;
        }
    }

    load(): Observable<MainConfigurationInterface> {
        if (this.mainConfiguration && !this.updateConfiguration) {
            return new Observable<MainConfigurationInterface>((observer) => {
                observer.next(this.mainConfiguration);
                observer.complete();
            });
        } else {
            let contentHeaders = new Headers();
            contentHeaders.append('Accept', 'application/json');
            contentHeaders.append('Content-Type', 'application/json');
            let url = CONFIG.apiDomain + CONFIG.apiPath + CONFIG.configurationFiles[this.storeId] + '?v=' + Math.random();

            // this.logger.debug(url);
            return this.http.get(url, { headers: contentHeaders })
                .map((res: Response) => {
                    let body = res.json();
                    this.mainConfiguration = this.defaultConfiguration;
                    // debugger;
                    if (res.ok) {
                        let conf = this.defaultConfiguration;
                        if (this.validateConfiguratorConfig(body)) {
                            conf = body as MainConfigurationInterface;
                        }
                        conf.Room.forEach((room) => {
                            this.roomConfiguration.push(room);
                        });
                        this.mainConfiguration = conf;

                        return conf;
                    } else {
                        return this.defaultConfiguration;
                    }
                })
                .catch(this.handleError);
        }
    }

    getConfiguration(roomNumber): Observable<{ main: MainConfigurationInterface, room: RoomConfigurationInterface }> {
        let roomIndex = roomNumber - 1;
        if (roomIndex < 0) {
            roomIndex = 0;
        }

        return this.load().map((conf: MainConfigurationInterface) => {
            let room = typeof this.roomConfiguration[roomIndex] !== 'undefined' ? this.roomConfiguration[roomIndex] : this.roomConfiguration[0];
            return { main: conf, room: room };
        }).catch(this.handleError);
    }


    loadProductsForRoom(room: RoomConfigurationInterface): Observable<Array<ProductGroup>> {
        let inputGroupsArray = room.ProductGroup;

        return new Observable<Array<ProductGroup>>((observer) => {
            let contentHeaders = new Headers();
            contentHeaders.append('Accept', 'application/json');
            contentHeaders.append('Content-Type', 'application/json');
            this.http.get(CONFIG.apiDomain + CONFIG.apiPath + CONFIG.magentoProductFiles[this.storeId], { headers: contentHeaders })
                .subscribe((data) => {
                    let index = 0;
                    let res = [];
                    let magentoParsedProducts;

                    if (data.ok) {
                        magentoParsedProducts = data.json();
                    }

                    inputGroupsArray.forEach((pGroup) => {
                        index++;
                        pGroup.jsonPosition = index;

                        let productsUrl = CONFIG.apiDomain + CONFIG.apiPath + pGroup.Table;
                        let subProductsUrl = typeof pGroup.SubProductTable !== 'undefined' ? (CONFIG.apiDomain + CONFIG.apiPath + pGroup.SubProductTable) : null;

                        let products = [];
                        let subProducts = [];
                        (new Observable<ProductGroup>((obs) => {
                            Papa.parse(productsUrl, {
                                download: true,
                                header: true,
                                complete: (results, file) => {
                                    // let filterBy = typeof pGroup.FilterBy !== 'undefined' ? pGroup.FilterBy : [];
                                    let filterBy = [];
                                    if (typeof pGroup.FilterBy !== "undefined") {
                                        pGroup.FilterBy.forEach((type) => {
                                            this.translate.get(type).subscribe((res: string) => {
                                                filterBy.push(res);
                                            });
                                        });
                                    }

                                    results.data.forEach((obj: any) => {
                                        if (typeof obj.ID !== 'undefined' && typeof obj.ArticleNumber !== 'undefined' && typeof obj.Title !== 'undefined') {
                                            let currentProduct = new Product(obj, filterBy);

                                            if (magentoParsedProducts) {
                                                if (obj.ArticleNumber in magentoParsedProducts) {
                                                    const magentoProduct = magentoParsedProducts[obj.ArticleNumber];

                                                    currentProduct.title.setValue(magentoProduct.name);
                                                    currentProduct.description.setValue(magentoProduct.short_description);
                                                    currentProduct.price.setValue(magentoProduct.final_price);
                                                    currentProduct.url.setValue(this.mainConfiguration.MagentoUrl + magentoProduct.url_key);
                                                }
                                            }

                                            products.push(currentProduct);
                                        }
                                    });

                                    if (subProductsUrl !== null) {
                                        Papa.parse(subProductsUrl, {
                                            download: true,
                                            header: true,
                                            complete: (results, file) => {
                                                results.data.forEach((obj: InputSubProductInterface) => {
                                                    if (typeof obj.ID !== 'undefined' && typeof obj.ArticleNumber !== 'undefined' && typeof obj.Title !== 'undefined') {
                                                        let currentSubProduct = new SubProduct(obj);

                                                        if (magentoParsedProducts) {
                                                            // console.log('magentoParsedProducts');
                                                            if (obj.ArticleNumber in magentoParsedProducts) {
                                                                const magentoProduct = magentoParsedProducts[obj.ArticleNumber];

                                                                // console.log(currentSubProduct);

                                                                currentSubProduct.title.setValue(magentoProduct.name);
                                                                // currentSubProduct.description.setValue(magentoProduct.short_description);
                                                                currentSubProduct.price.setValue(magentoProduct.price);
                                                                currentSubProduct.url.setValue(this.mainConfiguration.MagentoUrl + magentoProduct.url_key);
                                                            }
                                                        }

                                                        subProducts.push(currentSubProduct);
                                                    }
                                                });

                                                setTimeout(function () {
                                                    obs.next(new ProductGroup(pGroup, products, subProducts));
                                                    obs.complete();
                                                }, 1000);

                                            }
                                        });
                                    } else {
                                        setTimeout(function () {
                                            obs.next(new ProductGroup(pGroup, products, subProducts));
                                            obs.complete();
                                        }, 1000);
                                    }

                                }
                            });

                        })).subscribe((productGroup: ProductGroup) => {
                            res.push(productGroup);

                            if (res.length === inputGroupsArray.length) {
                                res.sort((group: ProductGroup, group2: ProductGroup) => {
                                    if (group.getJsonPosition() < group2.getJsonPosition()) {
                                        return -1;
                                    } else if (group.getJsonPosition() > group2.getJsonPosition()) {
                                        return 1;
                                    } else {
                                        return 0;
                                    }
                                });

                                observer.next(res);
                                observer.complete();
                            }

                            /*
                                if (res.length === inputGroupsArray.length) {
                                    res.sort((group: ProductGroup, group2: ProductGroup) => {
                                        console.log(group);
                                        if (group.getName() > group2.getName()) {
                                            return 1;
                                        } else if (group.getName() < group2.getName()) {
                                            return -1;
                                        } else {
                                            return 0;
                                        }
                                    });
        
                                    observer.next(res);
                                    observer.complete();
                                }
                            */

                            /*
                                res.sort((group: ProductGroup, group2: ProductGroup) => {
                                    // console.log(group.getDepthValue() + " === " + group2.getDepthValue());
                                    if (group.getDepthValue() < group2.getDepthValue()) {
                                        return -1;
                                    } else if (group.getDepthValue() > group2.getDepthValue()) {
                                        return 1;
                                    } else {
                                        return 0;
                                    }
                                });
                            */
                        });
                    });
                });
        });
    }


    private validateConfiguratorConfig(data) {
        if (typeof data.StartScreen === 'undefined') {
            return false;
        }

        if (typeof data.StartScreen.Title === 'undefined') {
            return false;
        }

        if (typeof data.StartScreen.Subtitle1 === 'undefined') {
            return false;
        }

        if (typeof data.StartScreen.Subtitle2 === 'undefined') {
            return false;
        }

        if (typeof data.StartScreen.BackgroundImage === 'undefined') {
            return false;
        }

        if (typeof data.PriceUnit === 'undefined') {
            return false;
        }

        if (typeof data.Room === 'undefined' || data.Room.length === 0) {
            return false;
        }
        let isValid = true;
        data.Room.forEach((node) => {
            if (isValid) {
                if (typeof node.Name === 'undefined' || typeof node.Title === 'undefined' || typeof node.Subtitle1 === 'undefined' || typeof node.Subtitle2 === 'undefined' || typeof node.FirstPageImage === 'undefined' || typeof node.BaseImage === 'undefined' || typeof node.TopImage === 'undefined') {
                    isValid = false;
                    return false;
                }
                if (typeof node.ProductGroup === 'undefined' || node.ProductGroup.length === 0) {
                    isValid = false;
                    return false;
                }
                node.ProductGroup.forEach((pg) => {
                    if (typeof pg.Name === 'undefined' || typeof pg.Table === 'undefined' || typeof pg.ButtonPosX === 'undefined' || typeof pg.ButtonPosY === 'undefined' || typeof pg.DefaultChoice === 'undefined') {
                        isValid = false;
                        return false;
                    }
                });
            }

        });
        return isValid;
    }

    handleError(error: Response) {
        this.mainConfiguration = this.defaultConfiguration;
        let json = error.json();
        let msg = "server error, status " + error.status;
        if (json && json.message) {
            msg = json.message;
        }
        console.error(error.status + ": " + msg); // log to console instead

        return Observable.throw(msg);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/configuration.loader.ts